<template>
    <div>
        <v-card>
            <v-card-title>
                <span>General Holidays</span>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="dialog=true">New</v-btn>
            </v-card-title>
            <v-data-table :headers="headers" :items="package" :loading="loading">
                <template v-slot:items="props">
                    <td class="text-xs-left">{{ props.item.id }}</td>
                    <td class="text-xs-left">{{ props.item.name }}</td>
                    <td class="text-xs-left">{{ props.item.from }}</td>
                    <td class="text-xs-left">{{ props.item.to}}</td>
                    <td class="text-xs-left">
                        <v-icon
                                small
                                @click="deleteItem(props.item)"
                        >
                            delete
                        </v-icon>
                    </td>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="dialog" width="40%">
            <v-card>
                <v-card-title>
                    Add New Delay Policy
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="model.name" label="Name"></v-text-field>
                    <choose-date v-model="model.from" label="From"></choose-date>
                    <choose-date v-model="model.to" label="To"></choose-date>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="save" :disabled="loading">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";

    export default {
        name: "GeneralHolidays",
        title: "General Holidays",
        components: {ChooseDate, DataTable},
        data() {
            return {
                headers: [
                    {text: 'ID', value: 'id'},
                    {text: 'Name', value: 'name'},
                    {text: 'From', value: 'from'},
                    {text: 'To', value: 'to'},
                    {text: 'Actions', value: 'actions'},
                ],
                package: [],
                loading: false,
                search: '',
                dialog: false,
                model: {
                    employment_type_id: this.$route.params.id
                }
            };
        },
        mounted() {
            this.getData();
        },
        methods: {
            reset()
            {
                this.model.employment_type_id = this.$route.params.id;
            },
            getData() {
                this.loading = true;
                this.axios.get(this.api.ACTIONS.EMPLOYMENT_TYPE_GENERAL_HOLIDAY(this.$route.params.id))
                    .then(res => this.package = res.data.data)
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            },
            getDeleteData(item) {
                let method = "DELETE";
                let url = 'general_holiday' + "/" + item.id;
                return {data: {_method: method}, url};
            },
            save() {
                this.loading = true;
                this.axios.post(`general_holiday`, this.model)
                    .then((response) => {
                        this.getData();
                        this.dialog = false;
                        window.getApp.$emit("SHOW_TOAST", response.data.message);
                        this.reset()
                    })
                    .catch(({response}) => {
                        if (response && response.data && response.data.message)
                            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
                        else {
                            window.getApp.$emit('SHOW_TOAST', "Couldn't save (error happened check error log)!", 'red');
                        }
                    })
                    .finally(() => this.loading = false);
            },
            deleteItem(item){
                confirm('Are you sure you want to delete this item?') && (() => {
                    this.loading = true;
                    const props = this.getDeleteData(item);
                    this.axios.post(props.url, props.data).then(
                        () => {
                            window.getApp.$emit("SHOW_TOAST", "Deleted", "green");
                        }
                    ).catch(
                        ({response}) => {
                            if (response && response.data && response.data.message)
                                window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
                            else {
                                window.getApp.$emit('SHOW_TOAST', 'Error Happened (Check error log)', "red");
                                console.log(data);
                            }
                        }
                    )
                        .finally(() => {
                            this.loading = false;
                        });
                })()

            },
        }
    }
</script>

<style scoped>

</style>
